import { render } from "./APdfThumbnail.vue?vue&type=template&id=1028326b"
import script from "./APdfThumbnail.vue?vue&type=script&lang=js"
export * from "./APdfThumbnail.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__